import { useState } from "react";
import { Card, Table, Tag, Tooltip, Input, Empty } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import MondayButton from "../../../../commonComponents/MondayButton/MondayButton";
import GlobalPopupKonfirm from "../../../../commonComponents/GlobalPopupKonfirm";

// The corpus is public and broad, so the safety valve is subtractive: block a
// single line, or an author whose views do not belong on the company header.
function BlocklistCard({ blocked, isDarkMode, onBlockAuthor, onRemove }) {
  const [author, setAuthor] = useState("");

  const addAuthor = () => {
    const name = author.trim();
    if (!name) return;
    onBlockAuthor(name);
    setAuthor("");
  };

  const columns = [
    {
      title: "Lloji",
      dataIndex: "type",
      key: "type",
      width: 110,
      render: (value) =>
        value === "author" ? (
          <Tag color="volcano">Autor</Tag>
        ) : (
          <Tag color="red">Citim</Tag>
        ),
    },
    {
      title: "Përmbajtja",
      key: "content",
      render: (_, row) =>
        row?.type === "author" ? (
          row.author
        ) : (
          <div className="quoteCell">
            <span className="text">{row?.quote}</span>
            {!!row?.author && <span className="author">— {row.author}</span>}
          </div>
        ),
    },
    {
      title: "Bllokuar më",
      dataIndex: "date",
      key: "date",
      width: 130,
      render: (value) => value || "—",
    },
    {
      title: "",
      key: "actions",
      width: 60,
      render: (_, row) => (
        <GlobalPopupKonfirm
          okText="Po"
          cancelText="Jo"
          title="Ta heqim nga lista e bllokuar?"
          onConfirm={() => onRemove(row)}
          Button={
            <Tooltip title="Hiq">
              <DeleteOutlined />
            </Tooltip>
          }
        />
      ),
    },
  ];

  return (
    <Card
      className={`citimiCard ${isDarkMode ? "dark" : ""}`}
      title={`Të bllokuara (${blocked.length})`}
    >
      <div className="citimiFilters">
        <Input
          allowClear
          placeholder="Blloko një autor, p.sh. Friedrich Nietzsche"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          onPressEnter={addAuthor}
        />
        <MondayButton
          className="mondayButtonRed"
          Icon={<PlusOutlined />}
          onClick={addAuthor}
        >
          Blloko autorin
        </MondayButton>
      </div>

      {blocked.length ? (
        <Table
          rowKey={(row) => row?.id}
          size="small"
          dataSource={blocked}
          columns={columns}
          pagination={{ pageSize: 6, showSizeChanger: false }}
        />
      ) : (
        <Empty description="Asgjë e bllokuar deri tani" />
      )}
    </Card>
  );
}

export default BlocklistCard;
